/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { AsyncRequestState, RegionProxies, Runner } from '@modules/ui-types'

import { getProxies } from '@/reducers/proxies'
import { getRunner } from '@/reducers/runners'
import { fetchProxiesRequest } from '@/reducers/asyncRequests/registry'

import { fetchProxies } from '../../../actions/proxies'

import Proxy from './Proxy'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

type StateProps = {
  runner?: Runner
  proxies?: RegionProxies
  proxiesRequest: AsyncRequestState
}

type DispatchProps = {
  fetchProxies: () => void
}

type ConsumerProps = {
  regionId: string
  hostId: string
  startManagingRoles: () => void
}

const mapStateToProps = (state: ReduxState, { regionId, hostId }: ConsumerProps): StateProps => ({
  runner: getRunner(state, regionId, hostId),
  proxies: getProxies(state, regionId),
  proxiesRequest: fetchProxiesRequest(state, regionId),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { regionId }: ConsumerProps,
): DispatchProps => ({
  fetchProxies: () => dispatch(fetchProxies(regionId)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Proxy)
